module.exports = __webpack_public_path__ + "img/edge_activites_montagnes_russes.dde98762.svg";